import { useNavigate, useParams } from 'react-router-dom';
import { CurriculumGradesTable } from '../../../../../components/Curricula/Tables/CurriculumGradesTable';

export const CurriculumGradesSubpage = () => {
  const navigate = useNavigate();
  const { curriculumUuid } = useParams();

  return <CurriculumGradesTable curriculumUuid={curriculumUuid} onNavigate={(grade) => navigate(grade.toString())} />;
};
